import * as t from "./actions";
import { AggregatedMetrics, AnalyticsGlobalFilters } from "./constants";

export interface AnalyticsMetricContainerState {
  merchant_id: number;
  selectedMerchant: any;
  publications: any[]; //todo: create type for publication object
  publication_ids: number[];
  analytics_metrics: AggregatedMetrics;
  start_date: string;
  end_date: string;
  metrics_container_tab: string;
  publications_loading: boolean;
  analytics_metrics_loading: boolean;
  globalFilters: AnalyticsGlobalFilters;
  exportModalVisible: boolean;
}

let initialState: AnalyticsMetricContainerState = {
  merchant_id: null,
  publications: [],
  publication_ids: [],
  selectedMerchant: null,
  analytics_metrics: {
    spend: null,
    impressions: null,
    opens: null,
    unique_engaged_visits: null,
    clicks: null,
    shopping_list: null,
    ttm: null,
    time_on_flyer: null,
    page_views: null,
    item_views: null
  },
  start_date: null,
  end_date: null,
  metrics_container_tab: null,
  publications_loading: false,
  analytics_metrics_loading: false,
  globalFilters: {
    device: ["mobile", "desktop"],
    channel: ["hosted", "distribution"]
  },
  exportModalVisible: false
};

export default function (state = initialState, action: IPayload): any {
  switch (action.type) {
    case t.SET_AGGREGATED_METRICS_LOADING:
      return { ...state, analytics_metrics_loading: action.payload };

    case t.ADD_AGGREGATED_METRICS:
      return { ...state, analytics_metrics: action.payload };

    case t.RESET_AGGREGATED_METRICS:
      return { ...state, analytics_metrics: action.payload };

    case t.GET_AGGREGATED_METRICS_FAILURE:
      return state;

    case t.SET_PUBLICATIONS_LOADING:
      state = { ...state, publications_loading: action.payload };
      return state;

    case t.GET_PUBLICATIONS:
      return state;

    case t.ADD_PUBLICATIONS:
      state = { ...state, publications: action.payload };
      return state;

    case t.REMOVE_PUBLICATIONS:
      state = { ...state, publications: action.payload };
      return state;

    case t.GET_PUBLICATIONS_FAILURE:
      return state;

    case t.GET_TOPLINE_METRICS_FAILURE:
      return state;

    case t.SET_METRICS_CONTAINER_TAB:
      state = { ...state, metrics_container_tab: action.payload };
      return state;

    case t.SET_MERCHANT_SELECTION:
      state = { ...state, merchant_id: action.payload }; //, selectedMerchant: state.merchant.find((i: any) => i.id == action.payload)}
      return state;

    case t.SET_START_DATE:
      state = { ...state, start_date: action.payload };
      return state;

    case t.SET_END_DATE:
      state = { ...state, end_date: action.payload };
      return state;

    case t.SET_PUBLICATION_SELECTION:
      state = { ...state, publication_ids: action.payload };
      return state;

    case t.SET_GLOBAL_FILTERS:
      return { ...state, globalFilters: action.payload };

    case t.TOGGLE_EXPORT_MODAL:
      return { ...state, exportModalVisible: !state.exportModalVisible };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/Analytics/reducer.ts